import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import { Information } from "assets/icons";
import { MESSAGE_REGEX } from "helper/helper";
import UseContext from "hooks/useContext";
import StyledInput from "components/styledInput/StyledInput";

const Temporaire = () => {
    const { data, setData, language } = UseContext();
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.motifForm.${key}`, defaultValue);
    const [validMotif, setValidMotif] = useState(false);
    // Reopening the modal shows the motif already confirmed, as long as it is this one.
    const [message, setMessage] = useState(() => ({
        type: "4",
        message: data.motif?.type === "4" ? data.motif.message ?? "" : "",
    }));
    const [lengthMessage, setLengthMessage] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [validMessage, setValidMessage] = useState(false);
    const { toggle } = useModal();
    const verif = message.message.length;

    useEffect(() => {
        setValidMessage(MESSAGE_REGEX.test(message.message));

        if (verif <= 8) {
            setErrorMessage(true);
            setLengthMessage(false);
        } else {
            setErrorMessage(false);
            setLengthMessage(true);
        }
        if (message.motif !== "0") {
            setValidMotif(true);
        } else {
            setValidMotif(false);
        }
    }, [message, verif]);
    const handleMessage = (e) => {
        setMessage({ ...message, message: e.target.value });
    };
    const handleSubmit = () => {
        if (lengthMessage) {
            setData((prevData) => ({ ...prevData, motif: message }));
            toggle();
        }
    };
    return (
        <>
            <Modalheader hide={toggle} hideShow={true} closeLabel={language.getValue("missionCreation.modal.close", "Fermer")}>
                Contrat temporaire d’usage
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <form className="flex flex-col w-full gap-4 mt-4">
                    <StyledInput
                        type={"textarea"}
                        label={label("description", "Votre description")}
                        value={message.message}
                        maxLength={250}
                        hint={label("maxLengthHint", "250 caractères")}
                        onChange={handleMessage}
                    />
                    {errorMessage ? (
                        <p className="text-yellow-400 flex  items-center gap-4">
                            <Information wh={16} color={"#FFA43D"} />
                            {label(
                                "lengthError",
                                "Veuillez faire un message de plus de 10 caractères"
                            )}
                        </p>
                    ) : (
                        ""
                    )}
                </form>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={"LG"} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
};

export default Temporaire;
